import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { API_ENDPOINTS } from '@core/http/api-endpoints';
import type { PartnerApiBody, PartnerApiResponse } from '@typings/app/partner-openapi.helpers';
import { partnerContext } from './partner-http';

const EP = API_ENDPOINTS.partnerPortal;

type PartnerResponse = PartnerApiResponse<'/api/v1/partner-portal/partner', 'get'>;
type MeResponse = PartnerApiResponse<'/api/v1/partner-portal/me', 'get'>;
type ChangePasswordResponse = PartnerApiResponse<'/api/v1/partner-portal/me/password', 'post'>;

/** The signed-in partner user, their profile/password, and their partner (incl. subscription). */
@Injectable({ providedIn: 'root' })
export class PartnerAccountApiService {
  private readonly http = inject(HttpClient);

  getPartner(): Observable<PartnerResponse> {
    return this.http.get<PartnerResponse>(EP.partner, { context: partnerContext() });
  }

  getMe(): Observable<MeResponse> {
    return this.http.get<MeResponse>(EP.me, { context: partnerContext() });
  }

  updateMe(body: PartnerApiBody<'/api/v1/partner-portal/me', 'patch'>): Observable<MeResponse> {
    return this.http.patch<MeResponse>(EP.me, body, { context: partnerContext() });
  }

  changePassword(
    body: PartnerApiBody<'/api/v1/partner-portal/me/password', 'post'>,
  ): Observable<ChangePasswordResponse> {
    return this.http.post<ChangePasswordResponse>(EP.mePassword, body, {
      context: partnerContext({ skipErrors: true }),
    });
  }
}
